module.exports = __webpack_public_path__ + "static/02_ecommerce-452f2a2a16240370c2d675d82e219c76.svg";